import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { FrontendPermissions } from '@vierkant-software/types__api';
import { AuthGuard } from 'src/services/auth.guard';
import { APIStates, InternalAppService } from 'src/services/app.service';
import { LoadGuard } from 'src/services/load.guard';
import { CashRegisterActivateGuard } from './guards/cashregister-activate.guard';

const modalRoutes: string[] = [];
const routes: Routes = [
  {
    path:          'session/:studio/:sessionID',
    loadComponent: () => import('./standalone/empty/empty.page').then(m => m.EmptyPage),
    resolve:       {
      A: (route: ActivatedRouteSnapshot) => {
        const appService = inject(InternalAppService);
        if (appService.state === APIStates.loggedIn)
          return appService.__switchSession(route.params.studio, route.params.sessionID);
        return appService.__activateSession(route.params.studio, route.params.sessionID);
      }
    }
  },
  {
    // Checkout Pages
    path:         'checkout',
    loadChildren: () => import('./modules/cashregister/checkout.module').then(m => m.CheckoutModule),
    canActivate:  [CashRegisterActivateGuard, AuthGuard],
    data:         {
      permissions:        [FrontendPermissions.login_Cashbox],
      useDetachAttachKey: 'checkout',
    }
  },
  {
    path:         'config',
    loadChildren: () => import('./modules/cashregister/cashregister-terminal.page.module').then(m => m.CashRegisterTerminalPageModule),
    canActivate:  [CashRegisterActivateGuard],
    data:         {
      requiresLogin:          false,
      allowWhenNotConfigured: true,
      permissions:            [FrontendPermissions.login_Cashbox],
      useDetachAttachKey:     'cashregister-config',
    }
  },
  {
    path:       '',
    redirectTo: 'checkout/products',
    pathMatch:  'full'
  }
];

routes.forEach(route => {
  if (route.redirectTo) return;

  if (!route.data)
    route.data = {};

  if (!route.canMatch)
    route.canMatch = [];

  route.canMatch.push(LoadGuard);
  route.data['isCashRegister'] = true;
});

const combinedRoutes = routes.map(x => {
  if (modalRoutes.includes(x.path))
    return [x, {outlet: 'modal', ...x}];
  else return x;
}).flat(1);

export const CashRegisterRoutingRoutes: Routes = combinedRoutes;
